module.exports = __webpack_public_path__ + "static/media/iot.af882275.png";